import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { Toast } from 'primeng/toast';
import { AppSidebarComponent } from '../components/app-sidebar/app-sidebar.component';
import { UserActionMenuComponent } from '../components/user-action-menu/user-action-menu.component';
import { TenantBadgeComponent } from '../components/tenant-badge/tenant-badge.component';
import { OfflineBannerComponent } from '../components/offline-banner/offline-banner.component';
import { HelpButtonComponent } from '../components/help-button/help-button.component';
import { BillingBannerComponent } from '../components/billing-banner/billing-banner.component';
import { BillingStateService } from '@app/core/services/billing-state.service';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    InputTextModule,
    BadgeModule,
    ButtonModule,
    RippleModule,
    StyleClassModule,
    Toast,
    AppSidebarComponent,
    UserActionMenuComponent,
    TenantBadgeComponent,
    OfflineBannerComponent,
    BillingBannerComponent,
    HelpButtonComponent,
  ],
  templateUrl: './dashboard-layout.component.html',
  styles: [
    `
      .dashboard-layout {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
      }

      .header {
        background-color: #ffffff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        padding: 1rem;
      }

      .nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .main-content {
        display: flex;
        flex: 1;
      }

      .sidebar {
        width: 250px;
        background-color: #f8f9fa;
        padding: 1rem;
      }

      .content {
        flex: 1;
        padding: 1rem;
      }
    `,
  ],
})
export class DashboardLayoutComponent implements OnInit {
  private readonly billingState = inject(BillingStateService);

  activeTab1 = 0;

  activeTab2 = 5;
  protected readonly UserActionMenuComponent = UserActionMenuComponent;

  ngOnInit(): void {
    // One read of the billing status for the whole session, shared with the Billing page.
    // Failures are silent here: the banner is simply absent. The Billing page shows its own error.
    void this.billingState.refresh();
  }
}
